import styled from '@emotion/styled';

export const CustomerContacts = styled.div`
  max-width: 500px;
  padding: 16px 0;
`;

export const EditBillingProfilePaneContainer = styled.div`
  .inflight-invoice-banner {
    margin-top: 8px;
  }
`;
